import {on} from './util';

export default class {
    static init = () => {
        archetypes();
    }
}

function archetypes() {
    // on() binds eagerly (querySelectorAll().forEach(), see util.ts) — 0 matches = 0 listeners,
    // which is the guard on every other page; no redundant document.querySelector check needed.
    on('change', 'input[name="arc_from"],input[name="arc_to"]', (element: HTMLInputElement) => {
        let from = element.name === 'arc_from' ? element.value : document.querySelector<HTMLInputElement>('input[name="arc_from"]')?.value;
        let to   = element.name === 'arc_to'   ? element.value : document.querySelector<HTMLInputElement>('input[name="arc_to"]')?.value;
        // D-07: this handler only ever sets or deletes arc_from/arc_to on the URL; every other
        // existing param carries through untouched. from/to/yoy/year are never named by this
        // module in any direction, so a stray one on the URL is structurally inert.
        const params = new URLSearchParams(window.location.search);
        if (from) { params.set('arc_from', from); } else { params.delete('arc_from'); }
        if (to)   { params.set('arc_to', to); }     else { params.delete('arc_to'); }
        location.href = '?' + params.toString();
    });
}
